export enum FormToolPageDroppableContainerEnum {
  TEMPLATE_QUESTIONS = "template-questions",
  TEMPLATE_ACTIONS = "template-actions",
  SELECTED_QUESTIONS = "selected-questions",
  SELECTED_ACTIONS = "selected-actions",
}
